import {Action, createReducer, on} from '@ngrx/store';
import {
    locationsArticle,
    selectedArticleView,
    selectedGroup,
    visibilities,
    SEOTags,
    setNotification,
    resetNotifications,
    setBreadcrumb,
    setGroups,
    deleteNotification,
    setDynamicPageLinks,
    setVisitedArticle,
    resetLocationsArticle
} from '@store/actions/global.actions';
import {GlobalState, initialGlobalState} from '@store/state/global.state';
import {v4 as uuidv4} from 'uuid';

export const initialState: GlobalState = initialGlobalState();

const GlobalReducer = createReducer(
    initialState,
    on(setNotification, (state: GlobalState, {notification, notificationType}): GlobalState => {
            let notifications: null | {
                id: string,
                notification: string,
                type: 'info' | 'error'
            }[];
            if (state.notifications) {
                notifications = [...state.notifications];
                notifications.unshift({id: uuidv4(), notification: notification, type: notificationType});
            } else {
                notifications = [{id: uuidv4(), notification: notification, type: notificationType}];
            }
            return {
                ...state,
                notifications: notifications
            }
        }
    ),
    on(deleteNotification, (state: GlobalState, {id}): GlobalState => {
            let notifications = state.notifications?.filter(n => n.id != id) ?? null
            if (notifications && notifications.length == 0) {
                notifications = null;
            }
            return {
                ...state,
                notifications
            }
        }
    ),
    on(resetNotifications, (state: GlobalState, {types}): GlobalState => {
            let notifications = state.notifications?.filter(x => !types?.includes(x.type)) ?? null;
            if (notifications && notifications.length == 0) {
                notifications = null;
            }
            return {
                ...state,
                notifications
            }
        }
    ),
    on(setBreadcrumb, (state: GlobalState, {breadcrumb}): GlobalState => {
        return {
            ...state,
            breadcrumb: breadcrumb
        }
    }),
    on(setGroups, (state: GlobalState, {groups}): GlobalState => {
        return {
            ...state,
            groups
        }
    }),
    on(setDynamicPageLinks, (state: GlobalState, {dynamicPageLinks}): GlobalState => {
        return {
            ...state,
            dynamicPageLinks
        }
    }),
    on(locationsArticle, (state: GlobalState, {articleId, listRouterUrl, listQueryParams}): GlobalState => {
            return {
                ...state,
                locations: {
                    article: {
                        ...state.locations?.article,
                        id: articleId,
                        listRouterUrl,
                        listQueryParams
                    }
                }
            }
        }
    ),
    on(resetLocationsArticle, (state: GlobalState): GlobalState => {
            return {
                ...state,
                locations: undefined
            }
        }
    ),
    on(selectedArticleView, (state: GlobalState, {value}): GlobalState => {
        return {
            ...state,
            selected: {
                ...state.selected,
                articleView: value
            }
        }
    }),
    on(selectedGroup, (state: GlobalState, {value}): GlobalState => {
        return {
            ...state,
            selected: {
                ...state.selected,
                group: value
            }
        }
    }),
    on(setVisitedArticle, (state: GlobalState, {articleNumber}): GlobalState => {
        let visitedArticles = state.visitedArticles?.filter(r => r !== articleNumber) ?? [];
        visitedArticles.unshift(articleNumber);
        if (visitedArticles.length > 40) {
            visitedArticles.slice(visitedArticles.length - 1, 1);
        }
        return {
            ...state,
            visitedArticles
        }
    }),
    on(visibilities, (state: GlobalState, {property, value}): GlobalState => {
        return {
            ...state,
            visibilities: {
                ...state.visibilities,
                [property]: value
            }
        }
    }),
    on(SEOTags, (state: GlobalState, {title, description, keywords, useForUrl}): GlobalState => {
        return {
            ...state,
            SEO: {
                ...state.SEO,
                title,
                description,
                keywords,
                useForUrl
            }
        }
    })
);

export function reducer(state: GlobalState | undefined, action: Action) {
    return GlobalReducer(state, action);
}
